// This file is imported in all theme.liquid pages (most of Shopify pages uses theme.liquid).
import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import StickyProductBar from "@/components/StickyProductBar";

document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("sticky-product-bar", StickyProductBar);
});
